import React from 'react';
import { formatMoney, formatOdds } from '@/common/client';

function CombinationNg({ combination, stake, win, odds }) {
    return (
        <div className="row">
            <div className="col left">{combination} </div>
            <div className="col">{formatMoney(stake, 'EUR', 2)} </div>
            <div className="col">{formatOdds(odds)}</div>
            <div className="col">{formatMoney(win, 'EUR')}</div>
        </div>
    );
}

export default CombinationNg;
